import type { ConfiguredService } from '../types/service.types';

// Configured services are persisted verbatim into the quote snapshot, so every
// field is a semantic change the derived-to-quote sync effect must react to.
export function configuredServicesFingerprint(services: ConfiguredService[]): string {
    return JSON.stringify(services);
}
